export const DELETE_PV_VIDEO_LOADING = "delete/pv/video/loading"
export const DELETE_PV_VIDEO_ERROR = "delete/pv/video/error"
export const DELETE_PV_VIDEO_SUCCESS = "delete/pv/video/success"